import { ActuContext } from 'pages/actualite/[slug]';
import React, { ComponentProps, FC, useContext } from 'react';
import { ContentApi } from '@api/business/api.utils';
import { CommentsList } from '@components/content/CommentsList/CommentsList.component';

type Props = Omit<ComponentProps<typeof CommentsList>, 'contentType' | 'onCommentSubmit' | 'loadComments'>;

export const ActuComments: FC<Props> = ({ className, ...rest }) => {
  const {
    article: { initialData: article },
    commentsRef: { data: commentsRef },
    nbComments: { setData: setNbComments },
  } = useContext(ActuContext);

  async function loadComments(offset: number, limit: number) {
    if (!article) {
      return undefined;
    }

    const { data } = await ContentApi.getComments(article.id, offset, limit);

    if (setNbComments) {
      setNbComments(data.pagination.count);
    }

    return data;
  }

  async function submitComment(comment: string) {
    if (!article) {
      return undefined;
    }

    const { data: newComment } = await ContentApi.insertComment(article.id, { body: comment });
    return newComment;
  }

  return (
    <CommentsList
      ref={commentsRef}
      className={className}
      contentType={article}
      loadComments={loadComments}
      onCommentSubmit={submitComment}
      {...rest}
    />
  );
};
